import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getQuizzes(): Promise<void> {
    const { apiGetQuizzes } = apiConfig.getStaticUrls();

    return getFetch(apiGetQuizzes);
}
